import React from 'react';
function LogIn({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M11 17l5-5-5-5M16 12H4" />
    </svg>
  );
}

export default LogIn;
